import type { Cursor, EventDto } from "@nabla/api";

const stores = ["r", "c", "p", "a"] as const;
export type Store = (typeof stores)[number];

export type DurableEvent = Extract<EventDto, { cursor: Cursor }>;

const storeOfType = { mudanca: "r", dados: "a", agenda: "a", alerta: "a", atualizacao: "a", revisao: "a", conversa: "c", pessoas: "p" } as const satisfies Record<Exclude<DurableEvent["type"], "registro" | "modulo">, Store>;

function storeOfRow(id: string): Store {
  if (id.startsWith("r:")) return "r";
  return id.startsWith("p:") ? "p" : "a";
}

export function storeOf(event: DurableEvent): Store {
  if (event.type === "modulo") return event.store;
  return event.type === "registro" ? storeOfRow(event.item.id) : storeOfType[event.type];
}

export function covers(snapshot: Cursor, applied: Cursor): boolean {
  return stores.every((store) => snapshot[store] >= applied[store]);
}

const perStore = (pick: (a: number, b: number) => number) => (first: Cursor, ...rest: readonly Cursor[]): Cursor =>
  rest.reduce((held, { r, c, p, a }) => ({ r: pick(held.r, r), c: pick(held.c, c), p: pick(held.p, p), a: pick(held.a, a) }), first);

export const oldest = perStore(Math.min);
export const latest = perStore(Math.max);
